import { Button } from "@/components/ui/button";
import { Phone, Theater, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";

export const Navigation = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const interval = setInterval(() => {
      setShowPhone(prev => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMobileOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navLinks = [
    { id: "about", label: "O nas" },
    { id: "offer", label: "Oferta" },
    { id: "benefits", label: "Dlaczego warto?" },
    { id: "why-us", label: "Dlaczego my?" },
    { id: "kontakt", label: "Kontakt" },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || !isHomePage ? "bg-primary/95 backdrop-blur-xl shadow-lg shadow-black/10" : "bg-transparent"}`}>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-montserrat font-bold text-white flex items-center gap-2 group">
          <Theater className="w-8 h-8 text-accent group-hover:rotate-12 transition-transform duration-300" />
          <span>WystepKabaretu.pl</span>
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex gap-6 items-center">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="text-white/80 hover:text-white relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full"
            >
              {link.label}
            </button>
          ))}
          <Button 
            onClick={() => window.location.href = "tel:+48533333993"}
            className="bg-accent text-accent-foreground hover:bg-accent/90 w-[180px] transition-all duration-300 flex items-center justify-center gap-2 rounded-full font-semibold"
          >
            {showPhone ? (
              <>
                <Phone className="w-4 h-4" />
                +48 533 333 993
              </>
            ) : (
              "Zamów kabaret"
            )}
          </Button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${mobileOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
        <div className="bg-primary/98 backdrop-blur-xl border-t border-white/10 px-4 py-6 space-y-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="block w-full text-left text-white/80 hover:text-white py-2 text-lg font-medium transition-colors"
            >
              {link.label}
            </button>
          ))}
          <Button 
            onClick={() => window.location.href = "tel:+48533333993"}
            className="w-full bg-accent text-accent-foreground hover:bg-accent/90 rounded-full font-semibold"
          >
            {showPhone ? "+48 533 333 993" : "Zamów kabaret"}
          </Button>
        </div>
      </div>
    </nav>
  );
};
